import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { BasicScrollView } from "@/components/BasicScrollView";
import { RelativePathString, useLocalSearchParams, useRouter } from 'expo-router';
import Head from 'expo-router/head';
import * as AppUtils from '@/utilities/AppUtils';
import * as AppUtilities from "@/utilities/AppUtilities";
import * as AppConstants from "@/utilities/AppConstants";
import Footer from '@/components/Footer';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { CustomText } from '@/components/CustomText';
import { AppText } from '@/components/AppText';
import { Button, Hourglass } from 'react95-native-rabbl';
import { CommunityMembership } from '@/types/community_membership';
import { setData } from '@/state/user';
import * as AppConsts from '@/utilities/AppConsts';
import { Meta } from '@/components/Meta';
import Signin from '@/app/(stateful)/(contextful)/(universal-loggedinorout-stack)/signin';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    alignItems: 'center',
    backgroundColor: 'transparent',
    gap: 20,
  },
  contentWrapper: {
    padding: 20,
    gap: 20,
  },
});

export default function Approved() {
  const [error, setError] = useState<string>("");
  const domain = useSelector((state: RootState) => state.user.domain);
  const loggedIn = useSelector((state: RootState) => state.user.loggedIn);
  const {
    u,
  } = useLocalSearchParams<{
    u?: string,
  }>();
  const dispatch = useDispatch();
  const router = useRouter();

  const process = useCallback(async () => {
    AppUtilities.info("Approved.process");

    try {
      // Reset error which will show the hourglass
      setError("");

      const response = await AppUtilities.fetchOptionallyAuthorized(
        "Approved.process",
        "/rabbl/api/approved",
        "POST",
        {
          u: u,
          domain: domain,
        },
      );
      const membership: CommunityMembership = ((response as any).body as any).community_membership;
      dispatch(setData(response));
      router.replace(AppUtils.getProfileCreateNextPageLink(membership) as RelativePathString);

    } catch (e) {
      setError(AppUtilities.getErrors(e));
      AppUtils.showErrorToast(AppUtilities.getErrors(e), () => process(), true);
      AppUtilities.handleException(e, "Approved.process");
    }
  }, [u, domain]);

  useEffect(() => {
    if (loggedIn && process) {
      process();
    }
  }, [loggedIn, process]);

  return (
    <>
      <Meta title={"Payment approved"} />
      {
        loggedIn ?
            <BasicScrollView center={true}>
              <AppText>Processing approved payment...</AppText>
                {
                  error.length == 0 ?
                      <Hourglass size={AppConstants.LARGE_HOURGLASS_SIZE} />
                    :
                      <>
                        <AppText style={AppConstants.STYLES.fontBoldColorRed}>{error}</AppText>
                        <Button onPress={process}>Retry</Button>
                      </>
                }
              <Footer />
            </BasicScrollView>
          :
            <Signin simpleLoginStateUpdate={true} />
      }
    </>
  );
}
